import React from 'react';
import { NavLink, Outlet, useNavigate, Navigate } from 'react-router-dom';
import { LayoutDashboard, Ship, Package, MapPinned, BookOpen, HelpCircle, Inbox, Settings as SettingsIcon, LogOut, ExternalLink } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';

const NAV = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/cruises', label: 'Nile Cruises', icon: Ship },
  { to: '/admin/packages', label: 'Packages', icon: Package },
  { to: '/admin/tours', label: 'Tour Categories', icon: MapPinned },
  { to: '/admin/blog', label: 'Blog Posts', icon: BookOpen },
  { to: '/admin/faqs', label: 'FAQs', icon: HelpCircle },
  { to: '/admin/leads', label: 'Leads / Inquiries', icon: Inbox },
  { to: '/admin/settings', label: 'Site Settings', icon: SettingsIcon },
];

const AdminLayout = () => {
  const { username, checking, isAuthenticated, logout } = useAuth();
  const nav = useNavigate();

  if (checking) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading admin...</div>;
  if (!isAuthenticated) return <Navigate to="/admin/login" replace />;

  const doLogout = () => { logout(); nav('/admin/login'); };

  return (
    <div className="min-h-screen bg-[#f6f8fa] flex">
      <aside className="w-64 bg-[#1e3454] text-white flex flex-col fixed inset-y-0 left-0">
        <div className="p-6 border-b border-white/10">
          <div className="font-serif text-xl">Get Nile Cruise</div>
          <div className="text-xs uppercase tracking-widest text-[#a6b2b5] mt-1">Admin Panel</div>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? 'bg-white/15 text-white' : 'text-white/75 hover:bg-white/10 hover:text-white'}`}>
              <n.icon size={17} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-2">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-white/75 hover:bg-white/10 hover:text-white transition-colors">
            <ExternalLink size={16} /> View public site
          </a>
          <div className="px-3 py-2 text-xs text-white/60">Signed in as <span className="text-white">{username}</span></div>
          <Button onClick={doLogout} variant="ghost" className="w-full justify-start text-white/80 hover:bg-white/10 hover:text-white"><LogOut size={16} className="mr-2" /> Log out</Button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
